export default {
    DISCONNECTED: 'Falha ao buscar as informações.',
    LOST_SESSION: 'Perda de sessão! Você será redirecionado para a tela de login.',
    FORBIDDEN_MESSAGE: 'Você não possui permissão para acessar essa página. Você será redirecionado para a tela de listagem principal.',
    SALVANDO: '<i class="fas fa-redo fa-spin mr-1"></i> Salvando...',
    SALVO_AUTOMATICO: '<i class="fas fa-check mr-1"></i> Salvo Automaticamente',
    SALVO_AUTOMATICO_MOBILE: '<i class="fas fa-check mr-1"></i> Salvo',
    INDISPONIVEL: 'Sistema indisponível',
    UNKNOWN: 'Erro desconhecido.'
}
